import { SortableContext } from '@dnd-kit/sortable';
import React, { useMemo } from 'react';
import { DemeterDashboardWidgetLayoutType } from '../../../Generated/Raven-Demeter';
import { IDragAndDropWidget } from './DashboardCustomizationService';
import styles from './DragAndDropWrapper.module.scss';

interface IDashboardWidgetContainerProps {
    widgets: IDragAndDropWidget[];
    layoutType?: DemeterDashboardWidgetLayoutType;
}

const DashboardWidgetContainer: React.FC<IDashboardWidgetContainerProps> = (props: IDashboardWidgetContainerProps) => {
    const layoutType = useMemo(
        // eslint-disable-next-line no-confusing-arrow
        () =>
            props.layoutType === DemeterDashboardWidgetLayoutType.FullWidth
                ? DemeterDashboardWidgetLayoutType.FullWidth
                : DemeterDashboardWidgetLayoutType.HalfWidth,
        [props.layoutType],
    );

    const widgetIds = useMemo(() => props.widgets.map((widget) => widget.stableWidgetId), [props.widgets]);

    return (
        <div className={styles.dragAndDrop_droppable_row_container}>
            <SortableContext items={widgetIds}>
                <div className={styles.dragAndDrop_droppable_row_content}>
                    {props.widgets.map((widget) => (
                        <div
                            key={widget.stableWidgetId}
                            className={`${
                                layoutType === DemeterDashboardWidgetLayoutType.FullWidth
                                    ? styles.dragAndDrop_droppable_row_node_fullWidth
                                    : styles.dragAndDrop_droppable_row_node_halfWidth
                            }
                                `}
                        >
                            {widget.component}
                        </div>
                    ))}
                    {props.layoutType !== DemeterDashboardWidgetLayoutType.FullWidth && props.widgets.length === 1 && (
                        <div className={styles.dragAndDrop_droppable_row_node_halfWidth_dummy_div} />
                    )}
                </div>
            </SortableContext>
        </div>
    );
};

export default DashboardWidgetContainer;
